export default __webpack_public_path__ + "static/media/thin_x.59d05f32.svg";